module.exports = __webpack_public_path__ + "5d12cce576e7c11e4b2bfbc5067b1d84.svg";